import { Base, createApp } from "@studiometa/js-toolkit";
import { Figure } from "@studiometa/ui";
import { isDev } from "./config.js";
import Slider from "./organisms/Slider.js";
import SliderMenu from "./organisms/SliderMenu.js";
import Accordion from "./molecules/Accordion.js";
import Loader from "./molecules/Loader.js";
import Newsletter from "./molecules/Newsletter.js";
import Site from "./organisms/Site.js";
class App extends Base {
  mounted() {
    this.$log("mounted \u{1F389}");
  }
}
App.config = {
  log: isDev(),
  name: "App",
  components: {
    Figure,
    Slider,
    Accordion,
    SliderMenu,
    Site,
    Loader,
    Newsletter
  }
};
var app_default = createApp(App, document.body);
export {
  app_default as default
};


if (module.hot) {module.hot.accept(function(err) {
if (err) {
console.error(err);
}
});
}
